import { defineExtension } from "~/defineExtension/index.js";
import { zodSrcPath } from "~/defineExtension/zodTypes/zodSrcPath.js";
import { ApiAfterBuild as ApiAfterBuildAbstraction } from "~/abstractions/index.js";
import { z } from "zod";

export const ApiAfterBuild = defineExtension({
    type: "Api/AfterBuild",
    tags: { runtimeContext: "project", application: "api" },
    description: "Add custom logic to be executed after the API build process.",
    multiple: true,
    paramsSchema: ({ project }) => {
        return z.object({
            src: zodSrcPath({ project, abstraction: ApiAfterBuildAbstraction })
        });
    }
});
